import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";

import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';

import { UtilesService } from './utiles.service';
import { Indicadores } from '../Models/Indicadores';


@Injectable()
export class IndicadorService {

  constructor( private _http: Http,
    private _utiles: UtilesService) { }

    /**
     * Obtiene los indicadores por el punto de visita seleccionado
     * entre un rango de fechas
     * @param compania 
     * @param idPunto 
     * @param fecha1 
     * @param fecha2 
     */
    ObtenerVisitaClienteEnc(compania: string, idPunto: string, fecha1: Date, fecha2:Date): Observable<Indicadores[]> {

      try {
  
        let url = this._utiles.getURL("Indicador/VisitaClienteEnc/" + compania+"/"+idPunto+"/"+fecha1+"/"+fecha2+"/" );
  
        return this._http.get(url).map((response: Response) => {
          return <Indicadores[]>response.json();
        });
  
      } catch (error) {
  
        console.log(error);
      }
  
    }
  
    /**
     * obtiene los indicadores por chofer
     * entre un rango de fechas
     * y el estado seleccionado
     * @param compania 
     * @param idUsuario 
     * @param fecha1 
     * @param fecha2 
     * @param estado 
     */
    ObtenerEntregasChofer(compania: string, idUsuario: string,
       fecha1: Date, fecha2:Date, estado:string): Observable<Indicadores[]> {

      try {
  
        let url = this._utiles.getURL("Indicador/EntregasChofer/" + compania+"/"+idUsuario+"/"+
        fecha1+"/"+fecha2+"/"+estado+"/" );
  
        return this._http.get(url).map((response: Response) => {
          return <Indicadores[]>response.json();
        });
  
      } catch (error) {
  
        console.log(error);
      }
  
    }


    /**
     * obtiene el indicadorer de facturas por chofer
      * entre un rango por fecha
     * @param compania 
     * @param idUsuario 
     * @param fecha1 
     * @param fecha2 
     * @param estado 
     */
    ObtenerFacturasChofer(compania: string, idUsuario: string,
      fecha1: Date, fecha2:Date): Observable<Indicadores[]> {

     try {
 
       let url = this._utiles.getURL("Indicador/FacturasChofer/" + compania+"/"+idUsuario+"/"+
       fecha1+"/"+fecha2+"/");
 
       return this._http.get(url).map((response: Response) => {
         return <Indicadores[]>response.json();
       });
 
     } catch (error) {
 
       console.log(error);
     }
 
   }

   ObtenerProporcionEntregas(compania: string, 
    fecha1: Date, fecha2:Date): Observable<Indicadores[]> {

   try {

     let url = this._utiles.getURL("Indicador/proporcionEntregas/" + compania+"/"+ fecha1+"/"+fecha2+"/");

     return this._http.get(url).map((response: Response) => {
       return <Indicadores[]>response.json();
     });

   } catch (error) {

     console.log(error);
   }

 }

}
